module.exports = __webpack_public_path__ + "img/graphy-1.4d30eb8b.webp";